import React, { useEffect, useMemo } from 'react';
import AliasNavigationContextProvider from '../../../components/Builder/AliasNavigation';
import ExecutionHistory from '../../../components/ExecutionHistory';
import useCohortBuilderIdFromLocation from '../../../utils/routes/useCohortBuilderIdFromLocation';
import CohortBuilderController from './CohortBuilder';
import useUnmountCreateCohortEffect from './utils/useUnmountCreateCohortEffect';
import { BuilderContextProvider } from '../../../components/Builder/BuilderContext';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import isNil from 'lodash/isNil';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import { analysisSelector } from '../../../redux/selectors/analyses';
import { useAppSelector } from '../../../redux/hooks';

const CreateCohort = () => {
  const builderId = useCohortBuilderIdFromLocation();
  const { track } = useAnalytics();
  useUnmountCreateCohortEffect();

  useEffect(() => {
    track(
      pageViewed({
        category: 'cohorts',
        name: isNil(builderId) ? 'create cohort' : 'view cohort',
        id: builderId,
      }),
    );
  }, [builderId, track]);

  const currentAnalysisMemoizedSelector = useMemo(analysisSelector, []);
  const currentAnalysis = useAppSelector((state) =>
    currentAnalysisMemoizedSelector(state, builderId),
  );
  // if the schema is disabled then the builder should be hidden
  const isSchemaDisabled = currentAnalysis?.metadata?.query.schema.disabled;

  return (
    <AliasNavigationContextProvider>
      <BuilderContextProvider>
        {!isSchemaDisabled && <CohortBuilderController />}
        {builderId && <ExecutionHistory builderId={builderId} />}
      </BuilderContextProvider>
    </AliasNavigationContextProvider>
  );
};

export default CreateCohort;
